import './ReportPhotoList.scss';
import moment from 'moment';

export const ReportPhotoList = ({ reports, onClick, showDate, addBottomMargin }) => {
  return (
    <div className="report-photo-list">
      {reports.map((report, index) => (
        <ReportPhotoItem key={index} report={report} onClick={onClick} showDate={showDate} />
      ))}
      {addBottomMargin && <div className="bottom-margin" />}
    </div>
  );
};

const ReportPhotoItem = ({ report, onClick, showDate }) => {
  return (
    <div
      className="report-item"
      onClick={() => {
        onClick(report.analysisId);
      }}>
      <img src={report?.imageUrls?.skinHealth} alt="ReportIcon" />
      {showDate && <div className="report-item-content">{moment(report.createdAt).format('D MMM YYYY h:mm')}</div>}
    </div>
  );
};
